import { PenTool, Fingerprint, Palette, Type, Shirt, MonitorSmartphone, LayoutTemplate, Globe, Search, BookOpen, Share2, ShoppingCart, CalendarCheck, CalendarClock, LayoutDashboard, BarChart3, Workflow, Filter, Bot, BellRing } from 'lucide-react';
import { PageShell, ServiceHero, ServiceGrid, CTAFinal, ServiceLinks } from './Shared';
import { useLang } from '../../i18n';

const ICON_SETS = {
    branding: [PenTool, Fingerprint, Palette, Type, Shirt, MonitorSmartphone],
    digitalizacion: [LayoutTemplate, Globe, Search, BookOpen, Share2, ShoppingCart],
    automatizacion: [CalendarCheck, CalendarClock, LayoutDashboard, BarChart3, Workflow, Filter, Bot, BellRing],
};

export default function ServiceDetail({ id, itemPrefix, count, heroTestid, gridTestid, ctaTestid }) {
    const { t } = useLang();
    const icons = ICON_SETS[id];
    const items = Array.from({ length: count }, (_, i) => ({
        icon: icons[i],
        title: t(`${itemPrefix}${i + 1}_t`),
        desc: t(`${itemPrefix}${i + 1}_d`),
    }));

    return (
        <PageShell titleKey={`${id}_meta_t`} descKey={`${id}_meta_d`} path={`/servicios/${id}`} waKey={`wa_${id === 'automatizacion' ? 'automatizacion' : id}`}>
            <ServiceHero eyebrowKey={`sp_name_${id}`} h1Key={`${id}_h1`} introKey={`${id}_intro`} testid={heroTestid} />
            <section className="py-20 lg:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <ServiceGrid items={items} testid={gridTestid} />
                </div>
            </section>
            <CTAFinal text={t(`${id}_cta`)} message={t(`wa_${id}`)} testid={ctaTestid} />
            <ServiceLinks currentId={id} />
        </PageShell>
    );
}
